module.exports = __webpack_public_path__ + "static/media/cherry-theme.1bb765f9.wav";